module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[62]61.807859d.woff2";